import translate from 'angular-translate';

var template = `<div class="cl-banner" ng-hide="$ctrl.hide || $ctrl.interacted">
    <ng-transclude></ng-transclude>
    <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.interact()" aria-label="Close">
      close <span aria-hidden="true">&times;</span>
    </button>
</div>`;

export default angular.module('eventix.common.directives.cookieLaw', [translate])
    .component('cookieLaw', {
        template: template,
        controller: CookieLawController,
        transclude: true,
        bindings: {
            text: '@',
        }
    }).name;

function CookieLawController($element, $translate, $scope, $window, $attrs, store) {
    const $ctrl = this;
    let storeName = 'ev_cookie_accepted_store';
    $ctrl.hide = SHOP_ENABLE_PRIVACY !== true;
    $ctrl.interacted = !!store.get(storeName);
    $ctrl.interact = interact;
    function interact() {
        store.set(storeName, true);
        $ctrl.interacted = true;
    }

}
